import { render, staticRenderFns } from "./CardIteratorStockItems.vue?vue&type=template&id=76ccde9e"
import script from "./CardIteratorStockItems.vue?vue&type=script&lang=js"
export * from "./CardIteratorStockItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76ccde9e')) {
      api.createRecord('76ccde9e', component.options)
    } else {
      api.reload('76ccde9e', component.options)
    }
    module.hot.accept("./CardIteratorStockItems.vue?vue&type=template&id=76ccde9e", function () {
      api.rerender('76ccde9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/CardIteratorStockItems.vue"
export default component.exports